import script from "./RefundAccept.vue?vue&type=script&setup=true&lang=js"
export * from "./RefundAccept.vue?vue&type=script&setup=true&lang=js"

import "./RefundAccept.vue?vue&type=style&index=0&id=d6090d32&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6090d32"]])

export default __exports__